
import styled from "styled-components";

const StyledRecipeDetailsInfo = styled.div`
    margin-left: 5rem;
    @media (max-width: 1068px) {
        margin-top: 3rem;
        margin-left: 1rem;
    }
`;

export default StyledRecipeDetailsInfo;
